import { ChangeDetectorRef, Directive, inject, ViewRef } from '@angular/core';
import { hlp_dateToISOString } from '@app/_v3/helpers/content-helpers';
import { DestroyableComponent } from './destroyable.component';
@Directive()
export abstract class ChangableComponent extends DestroyableComponent {
  protected readonly cdr = inject(ChangeDetectorRef);

  protected detectChanges() {
    if (this.cdr && !(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  protected markForCheck() {
    if (this.cdr && !(this.cdr as ViewRef).destroyed) {
      this.cdr.markForCheck();
    }
  }

  // Not sure we need it here, but i have no idea where else
  public hlp_dateToISOString = (date: any) => hlp_dateToISOString(date);
}
